import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { onPlayVideo } from '../../actions/media-player';
import { CorrectionContent } from '../../components/correction-content';
import { Subtitle, Title } from '../../components/exercise-load-error';
import { decorateExercise } from '../../lib/decorate-exercise';

export const GenericErrorHeading = () => (
    <>
        <Title>{'Oh no, qualcosa è andato storto!'}</Title>
        <Subtitle>{'Non siamo riusciti a caricare la correzione.'}</Subtitle>
    </>
);

export const ExerciseCorrectionPage = ({ geogebraExercises, onPlayVideo, videos }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const statusId = urlParams.get('statusId');
    const exerciseId = urlParams.get('exerciseId');
    const [exercise, setExercise] = React.useState(true);

    if (!statusId || !exerciseId) {
        return <GenericErrorHeading />;
    }

    const sessionStorageKey = `${statusId}_${exerciseId}`;
    const exerciseCorrectionDataString = sessionStorage.getItem(sessionStorageKey);

    sessionStorage.removeItem(sessionStorageKey);
    if (!exerciseCorrectionDataString) {
        return <GenericErrorHeading />;
    }

    let exerciseCorrectionData;
    try {
        exerciseCorrectionData = JSON.parse(exerciseCorrectionDataString);
    } catch (e) {
        return <GenericErrorHeading />;
    }

    const answer = exerciseCorrectionData.answer;
    decorateExercise(exerciseCorrectionData.exercise, null, true).then((decoratedExercise) => {
        setExercise(decoratedExercise);
    });

    const correctionStatus = exerciseCorrectionData.correctionStatus;
    if (!exercise || !correctionStatus) {
        return <GenericErrorHeading />;
    }

    return (
        <>
            <CorrectionContent
                answer={answer}
                correctionStatus={correctionStatus}
                exercise={exercise}
                geogebraExercises={geogebraExercises}
                onPlayVideo={onPlayVideo}
                solution={false}
                videos={videos}
            />
        </>
    );
};

ExerciseCorrectionPage.propTypes = {
    geogebraExercises: PropTypes.array,
    onPlayVideo: PropTypes.func,
    videos: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        geogebraExercises: state.homework.geogebraExercises,
        videos: state.mediaPlayer.videos,
    };
};

const actionCreators = {
    onPlayVideo,
};

export default connect(mapStateToProps, actionCreators)(ExerciseCorrectionPage);
